import React from 'react'

function points() {
  return (
    <div>points</div>
  )
}

export default points